import React, { useEffect, useState, useRef } from "react";
import { TokenVerificationLoggedin, BlockAdmin, BlockAM } from "../../../utils/tokenVerify"
import axios from "axios";
import Cookies from "js-cookie";
import configData from "../../../config/config.json";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import { Table, Select, Col, Row, Pagination, Input } from 'antd';
import { Link } from 'react-router-dom'
import FullLoader from "../../../assets/images/full-page-loader.gif"
import prevIcon from '../../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../../assets/images/icons/chevron-right.svg';
import noData from '../../../assets/images/data-graph/no-data.svg';
import TableLoader from "../.././TableLoader";
import addIcon from '../../../assets/images/icons/add.svg';
import errorData from '../../../assets/images/data-graph/error-data.svg';
import AdvertiserCreate from "./AdvertiserCreate";
import AdvertiserViewEdit from "./AdvertiserViewEdit";


const AdvertiserListing = () => {

    const [apiCall, setApicall] = useState(false)
    const [pageView, setPageView] = useState("table")

    const [advertiserViewId, setAdvertiserViewId] = useState("")
    const [advertiserViewName, setAdvertiserViewName] = useState("")

    const columnsAll = [

        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            // sorter: true,
            // sortDirections: ['ascend', 'descend', 'ascend'],
            fixed: 'left',
            width: 150,
            render: (text, record) => <div className='w_100 position-relative'>
                <Select
                    className={`form_select badge_content--${text === "Active" ? "approved" : "declined"}`}
                    dropdownStyle={{
                        width: '13rem'
                    }}
                    value={text}

                    options={
                        [
                            { value: 'Active', label: 'Active' },
                            { value: 'Suspended', label: 'Suspended' }]
                    }
                    onChange={(event) => {

                        let status = Cookies.get("token_xapads_ssp") ? true : false;
                        if (status) {
                            let token = Cookies.get("token_xapads_ssp");

                            let payload = {
                                "_id": record._id,
                                "status": event
                            }

                            setLoading(true)
                            axios
                                .put(configData.SERVER_URL + `advertiser/advStatus`, payload, {
                                    headers: {
                                        "Content-Type": "application/json",
                                        "x-access-token": token,
                                    },
                                })
                                .then((response) => {
                                    setApicall(!apiCall)
                                    notifysuccess(response.data.message);

                                })
                                .catch((error) => {
                                    if (error?.response) {
                                        if (error.response.data.message?.length !== 0) {
                                            notifyfailure(error.response.data.message)
                                        }
                                    } else {
                                        notifycatch()
                                    }
                                    setLoading(false)
                                });
                        }
                    }
                    }
                />
            </div>,
        },
        {
            title: "Advertiser Name",
            dataIndex: "name",
            width: 250,
            key: "name",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            fixed: 'left',
            render: (data, record) =>
                <div className='anchor_text_link_d2'
                    onClick={() => {
                        setPageView("viewAdvertiser");
                        setAdvertiserViewId(record._id)
                        setAdvertiserViewName(record.name)
                    }}
                >{data}</div>,

        },
        {
            title: "Email",
            dataIndex: "email",
            width: 250,
            key: "email",
            fixed: 'left',
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_ellipsis align_y_d2'>{data}</div>,
        },
        {
            title: "ADK Id",
            dataIndex: "advADK",
            width: 150,
            key: "advADK",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_ellipsis align_y_d2'>{data}</div>,
        },
        {
            title: "Xaprio Id",
            dataIndex: "advXaprio",
            width: 150,
            key: "advXaprio",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_ellipsis align_y_d2'>{data}</div>,
        },
        {
            title: "Aniview Id",
            dataIndex: "advAniview",
            width: 150,
            key: "advAniview",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data) => <div className='text_ellipsis align_y_d2'>{data}</div>,
        },
        {
            title: "Created By",
            dataIndex: "createdBy",
            width: 250,
            key: "createdBy",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => <div className='text_ellipsis align_y_d2'>{data}</div>,

        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            width: 200,
            key: "createdAt",
            sortDirections: ['ascend', 'descend', 'ascend'],
            sorter: true,
            render: (data, record) => <div className='text_ellipsis align_y_d2'>{data}</div>,

        },


    ];

    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const [initialLoad, setInitialLoad] = useState(true)

    const [page, setPage] = useState({
        current: 1,
        pageSize: 50,
        total: 10,
    });

    const [sort, setSort] = useState({
        name: "",
        type: ""
    });

    const [search, setSearch] = useState("")

    const getData = () => {
        setLoading(true)
        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {
            let token = Cookies.get("token_xapads_ssp");
            axios
                .get(configData.SERVER_URL + `advertiser/advList?sort=${sort.name}&order=${sort.type}&search=${search}&limit=${page.pageSize}&page=${page.current}`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                            "x-access-token": token,
                        },
                    })
                .then((response) => {
                    setData(response.data.data.data)
                    if (response.data.data.data.length > 0) {
                        let tempPage = { ...page }
                        tempPage.total = response.data.data.metaData?.totalRecords

                        setPage(tempPage)
                    }
                    setLoading(false)
                    setInitialLoad(false)
                })
                .catch((error) => {
                    setData([])
                    setLoading(false)
                    setInitialLoad(false)
                });
        }

    }

    useEffect(() => {
        TokenVerificationLoggedin();
        BlockAdmin()
        BlockAM()
        getData()
    }, []);



    useEffect(() => {
        if (!initialLoad) {
            getData()
        }
    }, [apiCall])

    useEffect(() => {
        if (!initialLoad) {
            const delayDebounceFn = setTimeout(() => {
                let tempPage = page
                tempPage.current = 1
                setPage(tempPage);
                setApicall(!apiCall)
            }, 400); // 500ms delay
            return () => clearTimeout(delayDebounceFn);
        }
    }, [search]);



    const handleTableChange = (pagination, filters, sorter) => {
        setSort({ name: sorter.field, type: sorter.order });
        setApicall(!apiCall)
    };

    const handlePageChange = (data) => {
        let tempPage = page
        tempPage.current = data
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const handlePageSizeChange = (e) => {
        let tempPage = page
        tempPage.pageSize = e

        if (tempPage.current > 1) {
            if (e * tempPage.current > tempPage.total) {
                tempPage.current = 1
            }
        }
        setPage(tempPage);
        setApicall(!apiCall)
    };

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const handlePageViewEdit = (data, reload) => {
        if (reload === "yes") {
            setApicall(!apiCall)
        }
        setAdvertiserViewId("")
        setAdvertiserViewName("")
        setPageView(data)
    }

    const locale = {
        emptyText:
            <>{search.trim().length > 0 && loading ?
                <div className='no_data_screen'>
                    <div className='text-center'>

                        <div className='float_text_div'>

                        </div>
                    </div>
                </div>
                :
                search.trim().length > 0 && !loading ?
                    <div className='no_data_screen'>
                        <div className='text-center'>
                            <img src={errorData} className='' alt="" />
                            <div className='float_text_div'>

                            </div>
                        </div>
                    </div>

                    :
                    loading ?
                        <div className='no_data_screen'>
                            <div className='text-center'>

                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
                        :
                        <div className='no_data_screen' >
                            <div className='text-center'>
                                <img src={noData} className='' alt="" />
                                <div className='float_text_div'>

                                </div>
                            </div>
                        </div>
            }
            </>

    };


    return (
        <>
            <div className="container_box--wrapper pt_header"
                style={{ opacity: pageView === "table" ? 1 : 0, display: pageView === "table" ? "block" : "none" }}
            >
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <h1 className="heading fw_600">
                        Advertisers
                    </h1>
                </div>

                <div className={data.length > 0 ? "table_and_filter_div --without_filter_div" : "table_and_filter_div --without_filter_div --no_data_div_height"}>
                    <div className="table_area_div">
                        <div className="searchbar_with_btns">
                            <div className="d_flex justify_content_between">
                                <div className="d_flex justify_content_between">
                                    <div className="form_content_block--group">
                                        {!initialLoad &&
                                            <Input
                                                type='text'
                                                className='form_control basic md search_input w_table_search'
                                                placeholder="Search"
                                                value={search}
                                                onChange={(e) => {

                                                    if (e.target.value.trim().length === 0) {
                                                        setLoading(true)
                                                    }

                                                    setSearch(e.target.value)
                                                }}
                                            />
                                        }
                                    </div>

                                </div>

                                <div className="btn_group">
                                    {!initialLoad &&
                                        <button className='btn btn_primary w_fit_content md'
                                            onClick={() => { setPageView("createAdvertiser") }}
                                        ><span><img src={addIcon} alt='USP' /> New Advertiser</span></button>
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="table_content--box --new_layout_table_design th_fixed_vertical_line table_empty_screen_d2">
                            {loading && !initialLoad &&
                                <div className="table_new_loader_d2">
                                    <img src={FullLoader} className="img-fluid" alt="" />
                                </div>
                            }

                            {initialLoad ?
                                <TableLoader />

                                :
                                <Table
                                    columns={columnsAll}
                                    pageSize={100}
                                    dataSource={data}
                                    onChange={handleTableChange}
                                    pagination={false}
                                    rowKey={(record) => record.id}
                                    locale={locale}
                                    scroll={{ x: 'max-content', y: 'calc(100vh - 30.9rem' }} />
                            }

                            {data.length > 0 &&
                                <Row className="custom_pagination--container">
                                    <Col span={6}>
                                        <div className="form_content_block--group mb_0">
                                            <Select
                                                className='form_select basic sm no_search'
                                                value={page.pageSize}
                                                onChange={handlePageSizeChange}
                                                style={{ width: 80 }}
                                                showSearch={false}
                                                options={[
                                                    { value: 10, label: 10 },
                                                    { value: 20, label: 20 },
                                                    { value: 50, label: 50 },
                                                    { value: 100, label: 100 },
                                                ]} />
                                            <label className='custom_pagination--label'>
                                                items per page
                                            </label>
                                        </div>
                                    </Col>
                                    <Col span={6}>
                                        <span className="custom_pagination--total-text">
                                            {`${(page.current - 1) * page.pageSize + 1}-${Math.min(page.current * page.pageSize, page.total)} of ${page.total} items`}
                                        </span>
                                    </Col>
                                    <Col span={6}>
                                        <Pagination
                                            current={page.current}  // Pass individual props instead of spreading them
                                            pageSize={page.pageSize}
                                            total={page.total}
                                            onChange={handlePageChange}
                                            showSizeChanger={false}
                                            itemRender={itemRender}
                                            className="custom_pagination" />
                                    </Col>
                                </Row>
                            }
                        </div>
                    </div>
                </div>
            </div>


            {pageView === "createAdvertiser" &&
                <AdvertiserCreate
                    handlePageViewChange={handlePageViewEdit}

                />
            }



            {pageView === "viewAdvertiser" &&
                <AdvertiserViewEdit
                    handlePageViewChange={handlePageViewEdit}
                    advertiserViewId={advertiserViewId}
                    advertiserViewName={advertiserViewName}
                />
            }

        </>
    );
};

export default AdvertiserListing;
